import dev from './config.ibmec.dev';
import hml from './config.ibmec.hml';
import local from './config.ibmec.local';
import prod from './config.ibmec.prod';

export default { local, dev, prod, hml };
